export default "__VITE_ASSET__dab428b1__"